// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__334KA","requiredAsterisk":"Info_requiredAsterisk__3D3wa"};